
import { defineComponent } from "vue";
import { createValidations, ICustomValidatorMap } from "@/helpers/commons/validationHelper";
import { AxiosResponse } from "axios";
import { VCodeMirror } from "vue3-code-mirror";
import useValidate from "@vuelidate/core";
import KnValidationMessages from "@/components/UI/KnValidatonMessages.vue";
import qbeDescriptor from "./DatasetManagementQbeDatasetDescriptor.json";
import Dropdown from "primevue/dropdown";
import Card from "primevue/card";
import Dialog from "primevue/dialog";
import QBE from "@/modules/qbe/QBE.vue";
import deepcopy from "deepcopy";

export default defineComponent({
  components: { Card, Dropdown, KnValidationMessages, Dialog, VCodeMirror, QBE },
  props: { parentValid: { type: Boolean }, selectedDataset: { type: Object as any }, dataSources: { type: Array as any }, businessModels: { type: Array as any } },
  emits: ["touched", "qbeDialogClosed", "qbeDialogSaved"],
  data() {
    return {
      qbeDescriptor,
      dataset: {} as any,
      v$: useValidate() as any,
      qbeQuery: "" as any,
      qbeQueryDialogVisible: false,
      qbeVisible: false,
      codeMirror: {} as any,
      qbeDataset: {} as any,
      selectedBusinessModel: {} as any,
      datsetBmChanged: false,
      getQueryFromDataset: false,
      codemirrorOptions: {
        readOnly: true,
        mode: "text/javascript",
        indentWithTabs: true,
        smartIndent: true,
        lineWrapping: true,
        matchBrackets: true,
        autofocus: true,
        theme: "eclipse",
        lineNumbers: true,
      },
    };
  },
  created() {
    this.dataset = this.selectedDataset;
    this.setupCodeMirror();
  },
  watch: {
    selectedDataset() {
      this.dataset = this.selectedDataset;
      this.setupCodeMirror();
    },
  },
  validations() {
    const qbeFieldsRequired = (value) => {
      return this.dataset.dsTypeCd != "Qbe" || value;
    };
    const customValidators: ICustomValidatorMap = { "qbe-fields-required": qbeFieldsRequired };
    const validationObject = { dataset: createValidations("dataset", qbeDescriptor.validations.dataset, customValidators) };
    return validationObject;
  },
  methods: {
    setupCodeMirror() {
      const interval = setInterval(() => {
        if (!this.$refs.codeMirror) return;
        this.codeMirror = (this.$refs.codeMirror as any).editor as any;
        setTimeout(() => {
          this.codeMirror.refresh();
        }, 0);
        clearInterval(interval);
      }, 200);
    },
    openQbeQueryDialog() {
      if (typeof this.dataset.qbeJSONQuery === "string") {
        this.qbeQuery = JSON.stringify(JSON.parse(this.dataset.qbeJSONQuery), null, 2);
      } else {
        this.qbeQuery = JSON.stringify(this.dataset.qbeJSONQuery, null, 2);
      }
      this.qbeQueryDialogVisible = true;
    },
    async getDriversData(event) {
      this.datsetBmChanged = true;
      this.getQueryFromDataset = false;
      const bmId = this.businessModels.find((bm) => bm.name === event.value).id;
      await this.$http
        .get(process.env.VUE_RESTFUL_SERVICES_PATH + `2.0/businessmodels/${bmId}`)
        .then((response: AxiosResponse<any>) => {
          this.selectedBusinessModel = response.data;
        })
        .catch();
    },
    openDatasetInQBE() {
      if (this.$route.name === "new-dataset") {
        this.qbeDataset = deepcopy(this.selectedBusinessModel);
        this.getQueryFromDataset ? (this.qbeDataset.qbeJSONQuery = this.dataset.qbeJSONQuery) : "";
      } else {
        if (this.datsetBmChanged) {
          this.qbeDataset = deepcopy(this.selectedBusinessModel);
        } else {
          this.qbeDataset = deepcopy(this.dataset);
        }
      }
      this.qbeDataset.dsTypeCd = "Qbe";
      this.qbeDataset.pars = this.dataset.pars;
      this.qbeVisible = true;
    },
    onQbeDialogClose() {
      this.qbeVisible = false;
    },
    onQbeDialogSave(query) {
      this.dataset.qbeJSONQuery = query;
      this.datsetBmChanged = false;
      this.getQueryFromDataset = true;
      this.qbeVisible = false;
    },
  },
});
